import { axios, getConfigs, IRequestConfig } from './api'

export interface DmpSubmission {
  id: number
  medicalOrderId: number | null
  createdAt: Date
  updatedAt: Date
  status: string
  error: string | null
  documents: number[]
  reports: number[]
}

export interface DmpParams {
  siteId?: number
  status?: string
  page?: number
  pageSize?: number
}

export interface PaginatedDmpSubmissionsResponse {
  items: DmpSubmission[]
  page: number
  pageSize: number
  totalCount: number
  totalPages: number
}

export class DmpService {
  static getDmpSubmissions(
    params: DmpParams,
  ): Promise<PaginatedDmpSubmissionsResponse> {
    return new Promise((resolve, reject) => {
      const url = 'dmp/submissions'

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        {
          params: {
            ...params,
          },
        },
      )

      axios(configs, resolve, reject)
        .then((res) => {
          resolve(res.data as PaginatedDmpSubmissionsResponse)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
